import useEvent from "react-use-event-hook";
import { useRecoilValue } from "recoil";

import { SimpleResult } from "@ryde/shared";

import { landingRoutesApiConst } from "../constants";
import {
  IPlaceInfoLandingModel,
  LandingResponseOfficialStationsByHomeAddressModel,
} from "../models";
import { landingCompanyIdSelector } from "../selectors";
import { useLandingApiMethods } from "./use-landing-api-methods";

export const useLandingApiStations = () => {
  // const { t } = useTranslation();
  const companyId = useRecoilValue(landingCompanyIdSelector);
  const stationsUrl = landingRoutesApiConst.stations(companyId as number);
  const { apiPost } = useLandingApiMethods();

  const getOfficialStationsByHomeAddress = useEvent(
    async ({
      homeAddress,
    }: {
      homeAddress: IPlaceInfoLandingModel;
    }): Promise<
      | SimpleResult<LandingResponseOfficialStationsByHomeAddressModel>
      | undefined
    > => {
      const response = await apiPost<
        | SimpleResult<LandingResponseOfficialStationsByHomeAddressModel>
        | undefined
      >(stationsUrl.getOfficialStationsByHomeAddress, {
        homeAddress,
      });

      return response?.data;
    },
  );

  // all fields that are sent will be saved in the database.
  const setPassengerPickupStation = useEvent(
    async ({
      homeAddress,
      sourceStation2Id,
      destinationStationId,
      passengerTypeId,
      unitId,
      workerId,
      age,
      firstName,
      lastName,
      phone,
      siteId,
      acceptTerms,
      acceptPrivacyPolicy,
    }: {
      homeAddress?: IPlaceInfoLandingModel;
      sourceStation2Id?: number;
      destinationStationId?: number;
      passengerTypeId?: number;
      unitId?: number;
      workerId?: string;
      age?: string;
      firstName?: string;
      lastName?: string;
      phone?: string;
      siteId?: number;
      acceptTerms?: boolean;
      acceptPrivacyPolicy?: boolean;
    }): Promise<SimpleResult<boolean> | undefined> => {
      const response = await apiPost<SimpleResult<boolean> | undefined>(
        stationsUrl.setPassengerPickupStation,
        {
          homeAddress,
          sourceStation2Id,
          destinationStationId,
          passengerTypeId,
          unitId,
          code: workerId,
          age,
          firstName,
          lastName,
          phone,
          siteId,
          acceptTerms,
          acceptPrivacyPolicy,
        },
      );

      return response?.data;
    },
  );

  return {
    getOfficialStationsByHomeAddress,
    setPassengerPickupStation,
  };
};
